import { Container, Typography, Box, Grid } from '@mui/material';
import Cards from "../components/Cards/Cards";

export default function Portfolio() {
  return (
    <Box sx={{ py: { xs: 6, md: 10 } }}>
      <Container maxWidth="lg">
        <Box sx={{ mb: 5, textAlign: 'center' }}>
          <Typography
            variant="h3"
            component="h2"
            sx={{
              mb: 1,
              fontWeight: 'bold',
              background: 'linear-gradient(45deg, #72efdd, #7E4DE2)',
              backgroundClip: 'text',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
            }}
          >
            Portfolio
          </Typography>
          <Typography
            variant="body1"
            sx={{
              color: 'rgba(255,255,255,0.7)',
              fontSize: '1.1rem',
            }}
          >
            A collection of my recent projects — click to see them live
          </Typography>
        </Box>

        <Grid
          container
          spacing={3}
          sx={{ justifyContent: 'center' }}
        >
          <Cards />
        </Grid>
      </Container>
    </Box>
  );
}
